    import { Fragment, useEffect, useRef, useState, useMemo, FC } from 'react';
    import { FacebookIcon } from '@ui/icons/social/facebook';
    import { InstagramIcon } from '@ui/icons/social/instagram';
    import { YoutubeIcon } from '@ui/icons/social/youtube';
    import { LandingNavbar } from '@app/landing/landing-navbar';
    import { Swiper, SwiperSlide } from "swiper/react";
    import "swiper/css";
    import "swiper/css/pagination";
    import { Pagination } from "swiper/modules";
    import { color, motion } from "framer-motion";
    import { Sparkles, User } from 'lucide-react';
    import { Shield, ShieldCheck, Share2, UserPlus, Upload, Globe2, Gift, SlidersHorizontal, Layers,FolderKanban, Rocket  } from "lucide-react";
    import {  Lock, Database, FileCheck, Users, Eye,  Globe , Zap , Heart , Clock , CloudUpload  } from 'lucide-react';
    import {  Megaphone , TrendingUp , Cloud, Building2, Compass, Briefcase,  } from 'lucide-react';
    import { BillingCycleRadio } from '@common/billing/pricing-table/billing-cycle-radio';
    import { PricingTable } from '@common/billing/pricing-table/pricing-table';
    import {
      ContactPagePayload,
      useSubmitContactForm,
    } from '@common/contact/use-submit-contact-form';
    import { useForm } from 'react-hook-form';
    import { Dialog } from '@ui/overlays/dialog/dialog';
    import { DialogBody } from '@ui/overlays/dialog/dialog-body';
    import { DialogHeader } from '@ui/overlays/dialog/dialog-header';
    import { DialogTrigger } from '@ui/overlays/dialog/dialog-trigger';
    import { FormTextField } from '@ui/forms/input-field/text-field/text-field';
    import { useRecaptcha } from '@common/recaptcha/use-recaptcha';
    import { Button } from '@ui/buttons/button';
    import { Trans } from '@ui/i18n/trans';
    import { Form } from '@ui/forms/form';
    import { UpsellBillingCycle } from '@common/billing/pricing-table/find-best-price';
    import { useProducts } from '@common/billing/pricing-table/use-products';
    import { CheckCircleOutlineIcon } from '@ui/icons/material/CheckCircleOutline';
    import { FullPageLoader } from '@ui/progress/full-page-loader';
    import { ArrowLeftIcon } from '@ui/icons/material/ArrowLeftIcon';
    import { ArrowRightIcon } from '@ui/icons/material/ArrowRightIcon';
    import { LucideIcon } from "lucide-react";
    import { useThemeSelector } from '@ui/themes/theme-selector-context';
    import { Helmet } from "@common/seo/helmet";
    import {
    AlertTriangle,
    CloudOff,Key,BarChart3,
    Users2,CloudCheck, HardDrive,
    AlertCircle
    } from "lucide-react";
    import "./cloud-storage-comparison.css";

    export function Harddrive() {
      const query = useProducts('pricingPage');
        const [selectedCycle, setSelectedCycle] =
          useState<UpsellBillingCycle>('month');
    
        const { selectThemeTemporarily } = useThemeSelector();
      useEffect(() => {
        selectThemeTemporarily('light');
        return () => selectThemeTemporarily(null);
      }, [selectThemeTemporarily]);
    
     const steps = [
        {
          icon: UserPlus,
          number: '01',
          title: 'Sign Up',
          description: 'Create your account in seconds with no credit card required',
        },
        {
          icon: Upload,
          number: '02',
          title: 'Upload Files',
          description: 'Upload files or sync folders instantly with secure, high-speed cloud storage',
        },
        {
          icon: Globe2,
          number: '03',
          title: 'Access Anywhere',
          description: 'Access your data from any device, anywhere in the world',
        },
      ];
    
      
    
      interface Card {
        icon: LucideIcon;
        title: string;
        description: string;
      }
        const [isMobile, setIsMobile] = useState<boolean>(false);
        const [hoverIndex, setHoverIndex] = useState<number | null>(null);
      
        useEffect(() => {
          const handleResize = () => {
            setIsMobile(window.innerWidth < 992);
          };
      
          handleResize();
          window.addEventListener("resize", handleResize);
          return () => window.removeEventListener("resize", handleResize);
        }, []);
      
        const card: Card[] = [
        {
          icon: FolderKanban,
          title: "Organized project assets",
          description: "Keep all marketing content and data sorted and accessible from one secure cloud platform.",
        },
        {
          icon: Globe  ,
          title: "Anywhere access",
          description: "Retrieve files remotely, enabling work from any device or location.",
        },
        {
          icon: ShieldCheck ,
          title: "Enhanced security",
          description: "Advanced encryption and backups protect sensitive digital marketing data.",
        },
        {
          icon: Users ,
          title: "Seamless collaboration",
          description: "Share and edit files with teams in real time for faster marketing execution.",
        },
      ];

      const cards  : {
          title: string;
          desc: React.ReactNode;
          icon: React.ReactNode;
          color: string;
        }[] = [
        {
          icon: <AlertCircle  className="w-24 h-24 text-white" />,
          title: " Easy to Damage or Fail",
          desc: "Hard drives are physical devices, which means they can stop working anytime. A small drop, heat, or wear over time can lead to data loss.",
          color: 'from-[#1E3A8A] to-[#3B82F6]',
        },
        {
          icon: <Database  className="w-24 h-24 text-white" />,
          title: "Limited Storage Space",
          desc: "You buy a hard drive with fixed storage, and once it's full, you need to purchase another one. This becomes expensive and inconvenient over time.",
          color: 'from-[#3B82F6] to-[#60A5FA]',
        },
        {
          icon: <Users2  className="w-24 h-24 text-white" />,
          title: "Slower Sharing & Collaboration",
          desc: "Sharing files from a hard drive is not easy. You have to manually transfer files, which wastes time and effort.",
          color: 'from-[#06B6D4] to-[#3B82F6]',
        },
          {
          icon: <CloudOff  className="w-24 h-24 text-white" />,
          title: "No Automatic Backup",
          desc: "Hard drives don't back up your files automatically. You have to manage everything yourself, which increases risk.",
          color: 'from-[#1E3A8A] to-[#06B6D4]',
        },
        {
          icon: <Clock  className="w-24 h-24 text-white" />,
          title: "Not Accessible Anytime",
          desc: "You can only access your files when you have the device with you. Forget it at home, and you’re stuck.",
          color: 'from-[#3B82F6] to-[#1E3A8A]',
        },
        {
          icon: <AlertTriangle  className="w-24 h-24 text-white" />,
          title: " Risk of Data Loss",
          desc: "If your hard drive gets corrupted, stolen, or damaged, your data can be permanently lost.",
          color: 'from-[#3B82F6] to-[#1E3A8A]',
        },
      ];
    
    const securityFeatures = [
        {
          icon: Gift,
          title: "25 GB Free Storage",
          description: "You get 25 GB of free space to start with, which is usually enough for daily files or basic work.",
        },
        {
          icon: ShieldCheck,
          title: " Secure Storage",
          description: "Your data stays protected, so you don't have to keep thinking about losing it or someone else getting into it.",
        },
        {
          icon: TrendingUp,
          title: "Globe",
          description: "You can check your files anytime, whether you're on your phone, laptop, or any other device.",
        },
        {
          icon: Sparkles,
          title: "Simple to Use",
          description: "It's made to be easy, so you won't have to spend time figuring out how things work.",
        },
        {
          icon: SlidersHorizontal,
          title: "Flexible Plans",
          description: "If you need more space later, you can upgrade whenever you want without any trouble.",
        },
      ];
    
      const features: {
            icon: LucideIcon;
            title: string;
            text: string;
          }[] = [
          {
            icon: HardDrive,
            title: "Access Files Anytime, Anywhere",
            text: " You can open your files anytime using your phone, laptop, or tablet. There is no need to carry any device with you.",
          },
          {
            icon: Globe,
            title: "No Risk of Physical Damage",
            text: "Your data is stored online, so you don't have to worry about damage, failure, or losing a device.",
          },
          {
            icon: TrendingUp,
            title: "Scalable Storage",
            text: "You can increase your storage space anytime based on your needs without buying new hardware.",
          },
          {
            icon: CloudCheck,
            title: "Automatic Backup ",
            text: "Your files are saved automatically, which helps you avoid losing important data.",
          },
          {
            icon: Share2,
            title: "Easy File Sharing",
            text: "You can quickly share files with anyone using a simple link, making work faster and easier.",
          },
          {
            icon: ShieldCheck,
            title: "Better Security",
            text: "Cloud storage uses strong security and encryption to keep your data safe and protected.",
          },
        ];
    
      const [openIndex, setOpenIndex] = useState<number | null>(0);
    
      const toggle = (index: number) => {
        setOpenIndex(openIndex === index ? null : index);
      };
    
      const faqData = [
          {
            question: "Why is there a shift from physical hardware to cloud architecture?",
            answer: "The <strong>shift from physical hardware to cloud architecture</strong> eliminates the risks of accidental device damage and wear-and-tear. Cloud architecture provides one of the best <strong>alternatives to external hard drives/USB flash drives</strong> by safely decentralizing files.",
          },
          {
            question: "What is the best alternative to a hard drive?",
            answer:
                "Cloud storage is one of the best alternatives because it lets you store your files online and access them anytime without depending on a physical device.",
          },
          {
            question: " Is SpaceByte Cloud storage safer than a hard drive?",
            answer:
              "Yes, SpaceByte Cloud Storage is generally safer since your data is protected with strong security and is not affected by physical damage like a hard drive.",
          },
          {
            question: "Is cloud storage easy to use for beginners?",
            answer:
              "Yes, most cloud storage platforms are designed to be simple, so anyone can upload, store, and share files without technical knowledge.",
          },
          {
            question: "Can I upgrade my storage later?",
            answer:
              "Yes, you can upgrade your storage anytime as your needs grow. There's no need to change anything; you can simply add more space whenever required.",
          },
          {
            question: "What are the hidden risks of physical storage?",
            answer: "Mechanical hard drives have moving parts and are fragile; a simple drop off a desk can result in catastrophic mechanical failure and expensive data recovery fees. A pendrive is easy to lose or corrupt, and a single virus from a public computer can wipe it out. This is why professionals are migrating to reliable cloud storage for real-time automatic backups."
          },
          {
            question: "Is cloud storage better than hard drive or local storage?",
            answer: "When evaluating <strong>cloud storage vs local storage</strong>, the biggest factor is data redundancy. <strong>Is cloud storage better than local storage</strong> or <strong>is cloud storage better than hard drive</strong>? Yes, because physical drives inevitably fail. Comparing <strong>cloud storage vs hard drive</strong> or <strong>cloud storage vs external hard drive</strong> reveals that hardware can be stolen or corrupted, while cloud storage guarantees secure, off-site availability.",
          },
          {
            question: "How does cloud storage compare to SSDs and NAS setups?",
            answer: "In the debate of <strong>cloud storage vs ssd</strong> or <strong>cloud storage vs external ssd</strong>, SSDs are fast but highly vulnerable to physical damage. Similarly, exploring <strong>cloud storage vs nas</strong> (Network Attached Storage) often leads users to ask, <strong>is nas better than cloud storage</strong>? While NAS provides local network speed, it requires expensive maintenance and IT knowledge. Instead of searching for the <strong>best nas for cloud storage</strong> or the <strong>best hard drive for cloud storage</strong>, transitioning fully from <strong>cloud storage vs physical storage</strong> (and <strong>cloud storage vs traditional storage</strong>) to SpaceByte offers zero-maintenance, globally accessible resilience.",
          }
        ];
      
        const [activeIndex, setActiveIndex] = useState<number>(0);
        const [visible, setVisible] = useState(false);
        const ref = useRef<HTMLDivElement | null>(null);
  
        
          useEffect(() => {
            const obs = new IntersectionObserver(
              ([e]) => {
                if (e.isIntersecting) setVisible(true);
              },
              { threshold: 0.12 }
            );
        
            if (ref.current) obs.observe(ref.current);
            return () => obs.disconnect();
          }, []);
        
          const [active, setActive] = useState("light");
    
            const trackRef = useRef<HTMLDivElement | null>(null);
            const [paused, setPaused] = useState(false);
          
    
          
    // const items = [...items, ...items];
          
            useEffect(() => {
              const track = trackRef.current;
              if (!track) return;
          
              let raf = 0;
              let x = 0;
          
              const speed = 0.65;
          
              const animate = () => {
                if (!paused) {
                  x -= speed;
          
                  const halfWidth = track.scrollWidth / 2;
                  if (Math.abs(x) >= halfWidth) x = 0;
          
                  track.style.transform = `translateX(${x}px)`;
                }
          
                raf = requestAnimationFrame(animate);
              };
          
              raf = requestAnimationFrame(animate);
          
              return () => cancelAnimationFrame(raf);
            }, [paused]);
    
             useStyles();
    
      const headerRef = useRef<HTMLDivElement>(null);
      const gridRef = useRef<HTMLDivElement>(null);
    
      useReveal(headerRef);
      useReveal(gridRef);
      
      const feature = [
      {
        icon: <HardDrive size={22} strokeWidth={2} className="text-[#0070ff]" />,
        label: "Storage",
        hdd: "It comes with fixed space, and once it’s full, you need another device",
        cloud: "You can increase storage anytime based on your needs",
      },
      {
        icon: <Key  size={22} strokeWidth={2} className="text-[#0070ff]" />,
        label: "Access",
        hdd: "You need the device with you to open your files",
        cloud: "You can access your files from anywhere, on any device",
      },
      {
        icon: <Shield  size={22} strokeWidth={2} className="text-[#0070ff]" />,
        label: "Safety",
        hdd: "Can get damaged, lost, or fail over time",
        cloud: "Your data stays safe with secure online protection",
      },
      {
        icon: <Share2 size={22} strokeWidth={2} className="text-[#0070ff]" />,
        label: "Sharing",
        hdd: "Sharing files takes extra steps like copying or transferring",
        cloud: "You can share files instantly with a simple link",
      },
      {
        icon: <Briefcase  size={22} strokeWidth={2} className="text-[#0070ff]" />,
        label: "Portability",
        hdd: "You have to carry the device everywhere",
        cloud: "No need to carry anything; everything is online",
      },
      {
        icon: <BarChart3  size={22} strokeWidth={2} className="text-[#0070ff]" />,
        label: "Scalability",
        hdd: "Not flexible, limited to device capacity",
        cloud: "Easily scalable whenever you need more space",
      },
      {
        icon: <Users size={22} strokeWidth={2} className="text-[#0070ff]" />,
        label: "Collaboration",
        hdd: "Not suitable for working together in real-time",
        cloud: "Multiple people can access and work on files easily",
      },
    ];

    const [activeRow, setActiveRow] = useState<number | null>(null);

      return (
        <Fragment>
    
          <Helmet>
            <title>Hard Drive Alternative | Smart Cloud Storage</title>
            <meta
              name="description"
              content="Hard drives are outdated for modern needs Switch to cloud storage for secure flexible and easy file access anytime without worrying about data loss."
            />
            <meta name="keywords" content="Hard Drive Alternative" />
            <link rel="canonical" href="https://spacebyte.in/hard-drive-alternative-cloud-storage" />
          </Helmet>
    
          <LandingNavbar
            color="transparent"
            className="fixed top-0 z-50 w-full flex-shrink-0 border-none bg-light-primary  shadow-lg"
            menuPosition="homepage-navbar"
          />
          
          <section className=" relative overflow-hidden !bg-gradient-to-r !from-[#0072ff]/8 !to-[#00c6ff]/8 py-24 md:py-32">
            <div className="absolute inset-0 opacity-5">
              <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
                    <path d="M 40 0 L 0 0 0 40" fill="none" stroke="#1E3A8A" strokeWidth="1" />
                  </pattern>
                </defs>
                <rect width="100%" height="100%" fill="url(#grid)" />
              </svg>
            </div>
            <div
              className={`landing-container z-10 flex flex-col items-center justify-between pb-40 pt-100 lg:flex-row`}
            >
              <div className="mx-auto w-full max-w-6xl px-4 text-center">
    
                {/* Heading */}
                <h1 className="font-archivo text-[40px] md:text-[60px] font-bold leading-[1.2] tracking-[-0.02em] text-[#1f2937]">
                  Switch from Hard Drives    {" "} 
                 <br /> to 
                 <span className="color-primary-gradient"> Cloud Storage </span>
                  
    
                </h1>
    
                {/* Sub heading */}
                <p className="mx-auto mt-30 max-w-3xl font-inter text-[18px] md:text-[20px]  text-[#6b7280]">
                Hard drives have been used for years, but with growing data and flexible work needs, people now prefer cloud storage for easier access, better safety, and convenience.
                </p>
    
              <div className="my-36 pb-20 flex flex-col items-center justify-center gap-6 sm:flex-row">
                <a
                  href="/register"
                  className="inline-flex items-center justify-center 
                  px-26 py-10 
                  text-white font-bold
                  bg-gradient-to-r from-[#0072ff] to-[#00c6ff]
                  shadow-lg transition-all duration-300
                  hover:from-[#0059d6] hover:to-[#00aaff]
                  hover:shadow-2xl hover:-translate-y-1"
                  style={{
                  borderRadius: "12px"
                }}
                >
                  Get 25 GB FREE
                </a>
                <a
                  href="/pricing"
                  className="inline-flex items-center justify-center
                  px-36 py-8 font-bold
                  text-[#0072ff]
                  relative transition-all duration-300
                  hover:-translate-y-1 hover:shadow-lg "
                  style={{
                    borderRadius: "12px",
                    background: "linear-gradient(#e5f5fb, #e5f5fb) padding-box, linear-gradient(90deg, #0072ff, #00c6ff) border-box",
                    border: "2px solid transparent"
                  }}
                  >
                  View Pricing
                </a>
              </div>
              </div>
            </div>
          </section>  
    
          <section className="py-24 md:py-32 bg-gradient-to-br from-[#F8FAFC] to-white relative overflow-hidden">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-5 landing-container z-10">
              <div className="absolute top-10 left-10 w-72 h-72 bg-[#3B82F6] rounded-full blur-3xl"></div>
              <div className="absolute bottom-10 right-10 w-96 h-96 bg-[#06B6D4] rounded-full blur-3xl"></div>
            </div>
    
            <div className="max-w-7xl mx-auto px-4 my-30 md:my-50 sm:px-6 lg:px-8 relative z-10">
              {/* Section Header */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="text-center mb-16"
              >
    
                <h2 className="text-3xl sm:text-4xl lg:text-5xl font-archivo font-bold text-[#111827] mb-10">
                  Start Your Cloud Storage in <span className="color-primary-gradient">Three Steps</span>{" "}
    
                </h2>
                <p className="text-lg text-[#6B7280] max-w-2xl mx-auto pb-10 font-archivo">
                  Start storing and sharing your files securely in minutes
                </p>
              </motion.div>
    
              {/* Steps */}
              <div className="grid md:grid-cols-3 gap-8 md:gap-12 relative landing-container">
                {/* Connecting Line */}
                <div className="hidden md:block absolute top-90 left-0 right-0 h-2 bg-gradient-to-r from-[#3B82F6] via-[#60A5FA] to-[#06B6D4] opacity-30"></div>
    
                {steps.map((step, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.2 }}
                    className="relative"
                  >
                    <div className="flex flex-col items-center text-center">
                      {/* Icon Circle */}
                      <div className="relative mb-6">
                        <div className="w-80 h-80 bg-gradient-to-br from-[#1E3A8A] to-[#3B82F6] rounded-full flex items-center justify-center relative z-10 shadow-lg">
                          <step.icon className="w-40 h-40 text-white" />
                        </div>
                        <div className="absolute -top-2 -right-10  w-40 h-40 bg-white rounded-full flex items-center justify-center border-2 border-[#3B82F6] z-20">
                          <span className="text-[#1E3A8A] font-bold text-sm">{step.number}</span>
                        </div>
                      </div>
    
                      {/* Content */}
                      <h3 className="text-2xl font-semibold font-archivo text-[#111827] my-20">
                        {step.title}
                      </h3>
                      <p className="text-[#6B7280] font-archivo max-w-xs">
                        {step.description}
                      </p>
                    </div>
                  </motion.div>
                ))}
              </div>
    
              {/* Animated Line */}
              <motion.div
                initial={{ scaleX: 0 }}
                whileInView={{ scaleX: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 1.5, delay: 0.5 }}
                className=" hidden md:block absolute top-[260px] left-[25%] right-[25%] h-3 bg-gradient-to-r from-[#3B82F6] to-[#06B6D4] rounded-full origin-left"
              ></motion.div>
            </div>
          </section>

          <section className="relative overflow-hidden bg-[#f5f8ff] py-30 text-black lg:py-50">
          <div className="landing-container z-10 flex flex-col items-center justify-between gap-8 px-4 md:px-8 lg:flex-row">
            {/* Left Section */}
            <div className="relative w-full lg:w-1/2 flex justify-center">
              <div className="relative w-full max-w-[520px]">

                {/* Background Offset Block */}
                <div className="absolute -bottom-4 -right-4 h-full w-full rounded-2xl bg-gradient-to-br from-blue-600 to-blue-400" />

                {/* Image */}
                <img
                  src="/images/hard-drive/hard-drive-alternative-cloud-storage.webp"
                  alt="Cloud storage as a smart alternative to external hard drives"
                  className="relative rounded-2xl shadow-2xl w-full object-cover"
                />
              </div>
            </div>

            {/* Right Content */}
            <div className="w-full space-y-16 lg:w-1/2 pt-14 md:pt-0">
              <h2 className="animate-fade-down font-archivo text-3xl font-bold md:text-4xl lg:text-5xl">
                What is the  <span className="color-primary-gradient">  Best Hard Drive </span> Alternative?
              </h2>
              <p className="color-gray font-inter animate-fade-down">
                Cloud storage is the best modern alternative to hard drives, keeping your data safe online without needing to carry any device. You can access and share your files anytime, from anywhere, making it a simple and reliable solution.
              </p>
            </div>
          </div>
          </section>          
    
      <section
        id="Pricing"
        className="pricing-section relative overflow-hidden bg-white py-40 text-black lg:py-50"
      >
        <div className="landing-container z-10">
          <div className="mx-auto max-w-xl space-y-16 text-center">
            <h2 className="animate-fade-down font-archivo text-3xl font-bold md:text-4xl lg:text-5xl">
              Affordable <span className="color-primary-gradient"> Cloud Storage Pricing </span> Plans
            </h2>
            <p className="color-gray font-inter animate-fade-down">
              Get affordable pricing with no hidden fees, encrypted cloud storage,
              and fast, seamless access to your files anytime, anywhere.
            </p>
          </div>

          <div className="my-40 flex flex-col md:flex-row justify-center items-center gap-16">
            <BillingCycleRadio
              products={query.data?.products}
              selectedCycle={selectedCycle}
              onChange={setSelectedCycle}
              className="input-radio animate-fade-up flex justify-center items-center flex-wrap"
              size="lg"
            />
          </div>

          <PricingTable
            selectedCycle={selectedCycle}
            productLoader="pricingPage"
            className="animate-fade-down"
          />

          {/* Premium Section */}
          <div
            className="premium-bg animate-fade-down bg-light-primary relative mt-40 flex flex-col items-center justify-between space-y-8 overflow-hidden rounded-2xl border-primary p-16 shadow-lg md:flex-row md:space-y-0 md:p-32"
            style={{
              backgroundImage:
                "url('/images/LandingImg/ctamask.png'), url('/images/LandingImg/ctashape.png')",
              backgroundSize: 'contain, contain',
              backgroundRepeat: 'no-repeat, no-repeat',
              backgroundPosition: 'left center, right center',
            }}
          >
            {/* Premium Tag */}
            <div className="font-archivo absolute -left-54 top-16 w-160 rotate-[-45deg] transform rounded bg-warning text-center text-sm font-medium text-black md:-left-56 lg:-left-50 lg:top-20">
              Premium
            </div>

            {/* Icon and Text */}
            <div className="flex flex-col items-center gap-8 space-y-8 md:flex-row md:space-x-8 md:space-y-0">
              <img
                src="/images/LandingImg/cta-icon.webp"
                className="color-primary rounded-lg bg-white p-16"
              />
              <div className="text-center md:text-left">
                <h2 className="font-archivo text-3xl font-bold">
                  5 TB or More?
                </h2>
                <span className="color-primary font-archivo text-2xl font-semibold">
                  ₹0.15/GB{' '}
                  <span className="text-lg font-normal text-black">
                    /Monthly
                  </span>
                </span>
                <p className="font-inter mt-8 flex items-start justify-center gap-4 text-sm md:justify-start">
                  <CheckCircleOutlineIcon size="sm" /> 100% Safe & Secure with
                  End-to-End Encryption
                </p>
                <p className="font-inter mt-1 flex items-start justify-center gap-4 text-sm md:justify-start">
                  <CheckCircleOutlineIcon size="sm" /> Calculate the cost or
                  Reach out to us
                </p>
              </div>
            </div>

            {/* Buttons */}
            <div className="flex flex-row flex-wrap gap-8 sm:flex-col lg:flex-row justify-center">
              <div className="flex justify-center">
                {CalculateDialogTrigger()}
              </div>

              <div className="mt-0 flex justify-center">
                <a href="/contact" className="btn bg-[#f9fafb] border-2 border-[#0072ff] text-black hover:bg-[#0072ff] hover:text-white">
                  <span>Contact Us</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

          <section className="relative overflow-hidden bg-[#f5f8ff]  py-24 md:py-32">
          <div className="landing-container z-10 mx-auto px-4">

            {/* Heading */}
            <div className="text-center mb-14">
                <h2 className="animate-fade-down font-archivo text-3xl font-bold md:text-4xl lg:text-5xl py-16 md:py-24">
                Problems with  <span className="color-primary-gradient">Hard Drives </span>              
                </h2>
                {/* <p className="color-gray font-inter animate-fade-down py-16 md:py-24">
                SpaceByte offers content creators 
                <span className="color-primary-gradient font-bold"> secure, fast, and scalable cloud storage</span>.
                Easily store, manage,  and share large videos, high-resolution images, and audio files
                    while collaborating seamlessly and focusing on your creative workflow.
                </p> */}
            </div>

        <Swiper
        modules={[Pagination]}
        spaceBetween={24}
        pagination={{
            clickable: true,
            el: ".custom-pagination",
        }}
        breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
        }}
        style={{ paddingBottom: "30px" }}
        >
        {cards.map((card, index) => (
            <SwiperSlide key={index} style={{ display: "flex", height: "auto" }}>
            
            <div
                className="group bg-white rounded-2xl 
                        p-14 md:p-16 lg:p-18
                        border border-gray-200
                        hover:border-[#3B82F6]/40 hover:shadow-xl
                        transition-all duration-300
                        flex flex-col flex-1 min-h-[250px]"
            >
                {/* ICON */}
                <div
                className={`w-40 h-40 md:w-50 md:h-50 
                            bg-gradient-to-br ${card.color}
                            rounded-xl flex items-center justify-center 
                            mb-12 transition-transform duration-300 
                            group-hover:scale-110`}
                >
                {card.icon}
                </div>

                {/* TITLE */}
                <h3 className="text-xl md:text-2xl font-semibold text-gray-900 mb-8">
                {card.title}
                </h3>

                {/* DESC */}
                <p className="color-gray font-base text-sm  leading-relaxed flex-grow">
                {card.desc}
                </p>
            </div>

            </SwiperSlide>
        ))}

        {/* 👇 Custom Pagination Below Cards */}
        <div
            className="custom-pagination"
            style={{
            marginTop: "40px",
            position: "relative",
            textAlign: "center",
            }}
        />
        </Swiper>
        </div>
          </section>

          <section id="security" className="py-24 md:py-40 bg-gradient-to-br from-white to-[#F8FAFC] relative overflow-hidden">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 landing-container z-10">
              {/* Section Header */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="text-center mb-16"
              >
                <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#111827] mb-12 md:mb-16">
                  Why Choose 
                  <span className="color-primary-gradient "> SpaceByte Cloud Storage?  </span>
                </h2>
                <p className="text-lg text-[#6B7280]  mx-auto">
                  If you're searching for a reliable alternative to a hard drive, SpaceByte makes it easier to store and manage your files without any stress
                </p>
              </motion.div>
    
              <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
                {/* Left - Illustration */}
                <motion.div
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  className="relative"
                >
                  <div className="relative">
                    {/* Main Shield */}
                    <div className="w-full max-w-md mx-auto aspect-square relative">
                      <div className="absolute inset-0 bg-gradient-to-br from-[#1E3A8A] to-[#3B82F6] rounded-3xl opacity-10 blur-3xl"></div>
                      <div className="relative w-full h-full flex items-center justify-center">
                        <div className="w-200 h-200 bg-gradient-to-br from-[#1E3A8A] to-[#3B82F6] rounded-full flex items-center justify-center shadow-2xl">
                          <Shield className="w-100 h-100 text-white" />
                        </div>
                      </div>
    
                      {/* Orbiting Icons */}
                      <motion.div
                        animate={{ rotate: 360 }}
                        transition={{ duration: 20, repeat: Infinity, ease: 'linear' }}
                        className="absolute inset-0"
                      >
                        {[Lock, Database, FileCheck, Users, Eye].map((Icon, index) => {
                          const angle = (index * 360) / 5;
                          const radius = 140;
                          const x = Math.cos((angle * Math.PI) / 180) * radius;
                          const y = Math.sin((angle * Math.PI) / 180) * radius;
    
                          return (
                            <motion.div
                              key={index}
                              animate={{ rotate: -360 }}
                              transition={{ duration: 20, repeat: Infinity, ease: 'linear' }}
                              className="absolute top-1/2 left-1/2 w-40 h-40 bg-white rounded-xl shadow-lg flex items-center justify-center"
                              style={{
                                transform: `translate(calc(-50% + ${x}px), calc(-50% + ${y}px))`,
                              }}
                            >
                              <Icon className="w-20 h-20 text-[#3B82F6]" />
                            </motion.div>
                          );
                        })}
                      </motion.div>
                    </div>
                  </div>
                </motion.div>
    
                {/* Right - Features List */}
                <motion.div
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  className="space-y-6"
                >
                  {securityFeatures.map((feature, index) => (
                    <motion.div
                      key={index}
                      initial={{ opacity: 0, x: 30 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      viewport={{ once: true }}
                      transition={{ delay: index * 0.1 }}
                      whileHover={{ x: 10 }}
                      className="flex items-start gap-6 group"
                    >
                      <div className="w-50 h-50 bg-gradient-to-br from-[#1E3A8A] to-[#3B82F6] rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                        <feature.icon className="w-11 h-11 text-white" />
                      </div>
                      <div>
                        <h3 className="text-xl font-semibold text-[#111827] mb-3 ml-16">
                          {feature.title}
                        </h3>
                        <p className="text-[#6B7280] pb-10 ml-16">{feature.description}</p>
                      </div>
                    </motion.div>
                  ))}
                </motion.div>
              </div>
            </div>
          </section>
                
          <section className="bg-white py-[80px] relative overflow-hidden ">
          <div className="landing-container z-10 max-w-[1140px] mx-auto px-[20px]">
            {/* Header */}
              <div className="text-center mb-14">
                  <h2 className="animate-fade-down font-archivo text-3xl font-bold md:text-4xl lg:text-5xl">
                  Why Secure Cloud Storage is  
                  <br />
                    <span className="color-primary-gradient"> Better Than Hard Drives</span>
                  
                  </h2>
                  {/* <p className="color-gray font-inter animate-fade-down py-16 md:py-24">
                    SpaceByte offers content creators 
                    <span className="color-primary-gradient font-bold"> secure, fast, and scalable cloud storage</span>.
                    Easily store, manage,  and share large videos, high-resolution images, and audio files
                      while collaborating seamlessly and focusing on your creative workflow.
                  </p> */}
              </div>
    
            {/* Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[24px] mt-[52px]">
              {features.map((item, index) => (
                <WhyCard
                  key={index}
                  item={item}
                />
              ))}
            </div>
          </div>
          </section>

          <section className="relative overflow-hidden bg-[#f5f8ff]  py-24 md:py-32">
        <div className="landing-container z-10">
              <div className="text-center mb-20">
                  <h2 className="animate-fade-down font-archivo text-3xl font-bold md:text-4xl lg:text-5xl">
                  Hard Drive vs   
                    <span className="color-primary-gradient"> Cloud Storage</span>
                  
                  </h2>
              </div>

          {/* Column labels */}
          <div className="sb-col-heads">
            <div className="sb-ch sb-ch-empty font-archivo" />
            <div className="sb-ch sb-ch-hdd font-archivo"><HardDrive size={22} strokeWidth={2} className="text-[#4a5d7a]" /> &nbsp; Hard Drive</div>
            <div className="sb-ch sb-ch-cloud font-archivo"><Cloud size={22} strokeWidth={2} className="text-[#0070ff]" /> &nbsp; SpaceByte Cloud</div>
          </div>

          {/* Comparison table */}
          <div className="sb-table">
            {feature.map((f, i) => (
              <div
                key={f.label}
                className={`sb-row${activeRow === i ? " sb-active" : ""}`}
                onMouseEnter={() => setActiveRow(i)}
                onMouseLeave={() => setActiveRow(null)}
              >
                <div className="sb-cell-feature">
                  <span className="sb-icon">{f.icon}</span>
                  <span className="sb-feature-name font-archivo">{f.label}</span>
                </div>
                <div className="sb-cell-hdd">
                  <p className="sb-hdd-text font-archivo">{f.hdd}</p>
                </div>
                <div className="sb-cell-cloud">
                  <p className="sb-cloud-text font-archivo">{f.cloud}</p>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>
    
          <section className="w-full px-4 md:px-10 py-40 bg-white relative overflow-hidden">
            <div className="landing-container min-h-[280px] md:min-h-[380px] flex items-center justify-center relative rounded-2xl overflow-hidden">
    
              {/* Video Background */}
              <video
                className="absolute inset-0 w-full h-full object-cover"
                src="/images/LandingImg/video.mp4"
                autoPlay
                loop
                muted
                playsInline
              />
    
              {/* Dark Overlay */}
              <div className="absolute inset-0 bg-black/60" />
    
              {/* Gradient Light */}
              <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/20 via-transparent to-blue-600/20" />
    
              {/* Content */}
              <div className="relative z-10 text-center max-w-4xl px-4">
                <h2 className="text-white text-3xl md:text-5xl font-semibold">
                  Your Data, Your Control, Your Cloud
                </h2>
    
                <p className="text-white/80 text-base md:text-lg mt-20">
                  A smarter cloud storage platform that gives you complete control over your data, file sharing, and digital privacy.
    
                </p>
    
                <div className="mt-20">
                  <a href="/contact" className="btn bg-white text-black px-20 py-10 rounded-xl font-medium hover:scale-105 transition">
                    <span>Contact Us</span>
                  </a>
                </div>
              </div>
    
            </div>
          </section>
          
          <section id="faq" className="bg-[#f5f8ff] relative overflow-hidden py-24 text-black lg:py-32">
            <div className="landing-container z-10">
              <div className="section-wrapper">
                <div className="section-inner">
                  {/* LEFT PANEL */}
                  <div className="left-panel">
                    <div className="badge font-archivo">
                      <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                        <circle cx="5" cy="5" r="5" fill="#38bdf8" />
                      </svg>
                      SpaceByte Cloud
                    </div>
    
                    <h2 className="left-title font-archivo">
                      Best Cloud Storage <br />
                      Secure, Fast and  <br />
                      Reliable
                    </h2>
    
                    <p className="left-sub font-archivo">
                      Everything you need to store, share, and access your files anytime, anywhere.
                    </p>
    
                    <div className="illustration">
                      <div className="illus-card">
                        <div className="illus-row">
                          <div className="illus-icon ic-blue">☁️</div>
                          <div className="illus-text font-archivo">
                            <strong>My Storage</strong>
                            <span>18.3 GB used of 25 GB</span>
                            <div className="illus-bar">
                              <div className="illus-bar-fill" style={{ width: "73%" }} />
                            </div>
                          </div>
                        </div>
    
                        <div className="illus-row">
                          <div className="illus-icon ic-sky">📁</div>
                          <div className="illus-text font-archivo">
                            <strong>Shared Folders</strong>
                            <span>12 folders · 3 collaborators</span>
                          </div>
                        </div>
    
                        <div className="illus-row">
                          <div className="illus-icon ic-white">🔒</div>
                          <div className="illus-text">
                            <strong>End-to-End Encrypted</strong>
                            <span>All files secured in transit</span>
                          </div>
                        </div>
    
                        <div className="stats-row">
                          <div className="stat-chip">
                            <strong>25 GB</strong>
                            <span>Free Storage</span>
                          </div>
                          <div className="stat-chip">
                            <strong>99.9%</strong>
                            <span>Uptime</span>
                          </div>
                          <div className="stat-chip">
                            <strong>24/7</strong>
                            <span>Support</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
    
                  {/* RIGHT PANEL */}
                  <div className="right-panel">
                    <p className="section-tag">Help Center</p>
    
                    <h2 className="section-title">
                      Quick Reference <br />
                      Guide
                    </h2>
    
                    <p className="section-desc">
                      Find answers to the most common questions about SpaceByte Cloud Storage.
                    </p>
    
                    <div className="accordion">
                      {faqData.map((item, index) => (
                        <div
                          key={index}
                          className={`acc-item ${openIndex === index ? "open" : ""}`}
                        >
                          <button className="acc-header" onClick={() => toggle(index)}>
                            <div className="acc-num">
                              {String(index + 1).padStart(2, "0")}
                            </div>
    
                            <span className="acc-label">{item.question}</span>
    
                            <div className="acc-chevron">
                              <svg viewBox="0 0 24 24" fill="none">
                                <polyline points="6 9 12 15 18 9" />
                              </svg>
                            </div>
                          </button>
    
                          <div className="acc-body">
                            <div
                              className="acc-body-inner"
                              dangerouslySetInnerHTML={{ __html: item.answer }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
    
          <section className="py-20 md:py-32 bg-gradient-to-br from-[#1E3A8A] via-[#3B82F6] to-[#60A5FA] relative overflow-hidden">
            {/* Animated Background */}
            <div className="absolute inset-0 landing-container z-10">
              <div className="absolute top-0 left-0 w-96 h-96 bg-white/10 rounded-full blur-3xl animate-pulse"></div>
              <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
            </div>
    
            {/* Grid Pattern */}
            <div className="absolute inset-0 opacity-10">
              <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <pattern id="cta-grid" width="40" height="40" patternUnits="userSpaceOnUse">
                    <path d="M 40 0 L 0 0 0 40" fill="none" stroke="white" strokeWidth="1" />
                  </pattern>
                </defs>
                <rect width="100%" height="100%" fill="url(#cta-grid)" />
              </svg>
            </div>
    
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-40 relative z-10">
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="text-center"
              >
                {/* Icon */}
                <motion.div
                  initial={{ scale: 0 }}
                  whileInView={{ scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ type: 'spring', delay: 0.2 }}
                  className="inline-flex items-center justify-center w-60 h-60 bg-white/20 backdrop-blur-sm rounded-2xl mb-12"
                >
                  <Sparkles className="w-30 h-30 text-white" />
                </motion.div>
    
                {/* Heading */}
                <motion.h2
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.3 }}
                  className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-white"
                >
                  Ready to Secure Your Data?
                </motion.h2>
    
                {/* Subheading */}
                <motion.p
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.4 }}
                  className="text-lg sm:text-xl text-white/90 my-16 max-w-2xl mx-auto"
                >
                  Join thousands of businesses trusting secure cloud storage to protect critical data.
    
                </motion.p>
    
                {/* CTA Button */}
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.5 }}
                  className="flex flex-col sm:flex-row gap-10 justify-center items-center"
                >
                  <a href="/register" className="group bg-white text-[#1E3A8A] px-16 py-14 rounded-xl font-semibold hover:bg-gray-100 transition-all hover:shadow-2xl hover:shadow-white/20 transform hover:-translate-y-1 flex items-center gap-2 btn">
                    Get 25 GB FREE - No Card Needed
                  </a>
    
                </motion.div>
    
                {/* Trust Badges */}
                <motion.div
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.6 }}
                  className="mt-20 flex flex-wrap justify-center items-center gap-8 text-white/80 text-sm"
                >
    
                </motion.div>
              </motion.div>
            </div>
          </section>
    
          <footer className="Footer-section relative overflow-hidden bg-[#0F172A] text-white pt-16 pb-8">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              {/* Main Footer Content */}
              <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8 mb-12">
                {/* Brand Column */}
                <div className="col-span-2 md:col-span-4 lg:col-span-2">
                  <div className="space-y-4 mr-12 padding-logo padding-top">
                    <a href="https://spacebyte.in/" className="flex-shrink-0">
                      <img
                        src="/images/logo-light.png"
                        alt="Logo"
                        className="site-logo"
                      />
                    </a>
                    <div>
                      <p className="font-medium pt-8 pb-10">SPACEBYTE CLOUD STORAGE</p>
                      <p className="pb-10 pt-3 flex items-center gap-2">
                        311, Maruti Plaza, Sardar Patel Chowk, Krishnanagar, Ahmedabad, Gujarat,
                        India - 382345</p>
                  <p className="pb-10 pt-3 flex items-center gap-2">
                    Mo. +91 97257 71457
                  </p>
                    </div>
                    <div>
                      <p className="font-bold text-base pb-10 pt-3">FOLLOW US FOR 'SPACEBYTE.IN'</p>
                      <div className="flex gap-4 mt-3 logg mb-10">
                        <ul className="flex space-x-16 pt-3 pr-10">
                          <li className="bg-light rounded-lg p-8">
                            <a href="https://www.facebook.com/profile.php?id=61567307277313&mibextid=ZbWKwL">
                              <FacebookIcon className="text-white" />
                            </a>
                          </li>
                          <li className="bg-light rounded-lg p-8">
                            <a href="https://www.instagram.com/spacebyte.in?igsh=MmZidnprMXZtbTho ">
                              <InstagramIcon className="text-white" />
                            </a>
                          </li>
                          <li className="bg-light rounded-lg p-8">
                            <a href="https://youtube.com/@spacebytecloudstorage?si=lt2mfOM7kSaN3g6B">
                              <YoutubeIcon className="text-white" />
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
    
                {/* Product Column */}
                <div className='py-8 md:py-20 px-30'>
                  <h2 className="font-semibold text-xl mb-10  text-start ">Product</h2>
                  <ul className="space-y-3 text-sm text-gray-400 text-start">
                    <li>
                      <a href="#features" className="hover:text-white transition-colors text-start">
                        Features
                      </a>
                    </li>
                    <li>
                      <a href="/Pricing" className="hover:text-white transition-colors">
                        Pricing
                      </a>
                    </li>
                    <li>
                      <a href="#security" className="hover:text-white transition-colors">
                        Security
                      </a>
                    </li>
                    <li>
                    </li>
                  </ul>
                </div>
    
                {/* Company Column */}
                <div className='py-8 md:py-20 px-30'>
                  <h2 className="font-semibold text-xl mb-10  text-start">Company</h2>
                  <ul className="space-y-3 text-sm text-gray-400 text-start">
                    <li>
                      <a href="/about-us" className="hover:text-white transition-colors">
                        About Us
                      </a>
                    </li>
                    <li>
                      <a href="/pages/articles" className="hover:text-white transition-colors">
                        Articles
                      </a>
                    </li>
                    <li>
                      <a href="/contact" className="hover:text-white transition-colors">
                        Contact Us
                      </a>
                    </li>
                  </ul>
                </div>
    
                {/* Resources Column */}
                <div className='py-8 md:py-20 px-30'>
                  <h2 className="font-semibold text-xl mb-10  text-start">Resources</h2>
                  <ul className="space-y-3 text-sm text-gray-400 text-start">
                    <li>
                      <a href="#faq" className="hover:text-white transition-colors">
                        FAQs
                      </a>
                    </li>
                    <li>
                      <a href="/contact" className="hover:text-white transition-colors">
                        Help Center
                      </a>
                    </li>
                    {/* <li>
                    <a href="https://spacebyte.in/api-docs" className="hover:text-white transition-colors">
                      Developers
                    </a>
                  </li> */}
                <li>
                  <a href="/storage/sitemaps/sitemap-index.xml" className="hover:text-white transition-colors">
                    Sitemap
                  </a>
                </li>
                  </ul>
                </div>
    
                {/* Legal Column */}
                <div className='py-8 md:py-20 px-30'>
                  <h3 className="font-semibold text-xl mb-10  text-start">Legal</h3>
                  <ul className="space-y-3 text-sm text-gray-400 text-start">
                    <li>
                      <a href="/pages/privacy-policy" className="hover:text-white transition-colors">
                        Privacy Policy
                      </a>
                    </li>
                    <li>
                      <a href="/pages/terms-of-service" className="hover:text-white transition-colors">
                        Terms of Service
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
    
              {/* Bottom Bar */}
              <div className="font-inter border-t border-t-primary/80 py-16 text-center mt-5">
                <p className="text-sm">
                  Copyright © {new Date().getFullYear()}{' '}
                  <a href="/login" className="color-primary-gradient">
                    SpaceByte Cloud Storage
                  </a>
                  , All Rights Reserved
                </p>
              </div>
            </div>
          </footer>
        </Fragment>
      );
    }
    
    function CalculateDialogTrigger() {
      const form = useForm<ContactPagePayload>({
        defaultValues: {
          message: '', // Initialize message field
        },
      });
      const [isOpen, setIsOpen] = useState(false);
      const [isContactDialogOpen, setIsContactDialogOpen] = useState(false);
      const submitForm = useSubmitContactForm(form);
      const { verify, isVerifying } = useRecaptcha('contact');
    
      return (
        <>
          <DialogTrigger type="modal" isOpen={isOpen} onOpenChange={setIsOpen}>
            <button className="btn w-full rounded-lg !text-white font-semibold
                            !bg-gradient-to-r !from-[#0072ff] !to-[#00c6ff]  shadow-lg
                            hover:shadow-xl transition">
              <span>Get Quote</span>
            </button>
            <Dialog className="w-full max-w-lg rounded-xl p-6">
              <DialogHeader
                className="font-archivo text-2xl font-semibold"
                showDivider
              >
                <Trans message="Storage Cost Calculator" />
              </DialogHeader>
              <DialogBody>
                <div className="font-inter flex items-center justify-center">
                  Enter the storage size (whole number greater than **5 TB**) to
                  calculate your monthly cost.
                </div>
                <Form
                  form={form}
                  className="mt-4 flex flex-col items-center text-center"
                  onSubmit={async value => {
                    calculateCost(value);
                  }}
                >
                  <FormTextField
                    label={<Trans message="Enter Storage in TB" />}
                    name="tb"
                    required
                    type="number"
                    className="mb-6 w-full rounded-lg p-2"
                  />
                  <div className="text-red-500 text-md" id="errorMsg"></div>
                  <div className="text-blue-500 text-md" id="resultOutput"></div>
                  <div className="mt-6 flex w-full justify-between gap-4">
                    <button className="btn-warning mt-16" type="submit">
                      Calculate
                    </button>
                    <Button
                      color="positive"
                      variant="outline"
                      className="mt-16 rounded-lg"
                      type="button"
                      onClick={() => {
                        const resultOutput =
                          document.getElementById('resultOutput')?.textContent;
                        form.setValue('message', resultOutput || ''); // Set the value of message field
                        setIsOpen(false); // Close current dialog
                        setIsContactDialogOpen(true); // Open Contact Us dialog
                      }}
                    >
                      Contact Us
                    </Button>
                  </div>
                </Form>
              </DialogBody>
            </Dialog>
          </DialogTrigger>
    
          {isContactDialogOpen && (
            <DialogTrigger
              type="modal"
              isOpen={isContactDialogOpen}
              onOpenChange={setIsContactDialogOpen}
            >
              <Dialog className="w-full max-w-lg rounded-xl p-6">
                <DialogHeader
                  className="font-archivo text-2xl font-semibold"
                  showDivider
                >
                  <Trans message="Contact Us" />
                </DialogHeader>
                <DialogBody>
                  {submitForm.isPending ? (
                    <FullPageLoader />
                  ) : (
                    <Form
                      form={form}
                      className="flex flex-col gap-4"
                      onSubmit={async value => {
                        const isValid = await verify();
                        if (isValid) {
                          submitForm.mutate(value, {
                            onSuccess: () => {
                              setIsContactDialogOpen(false); // Close the dialog on success
                            },
                          });
                        }
                      }}
                    >
                      <FormTextField
                        label={<Trans message="Name" />}
                        name="name"
                        required
                        className="rounded-lg p-2"
                      />
                      <FormTextField
                        label={<Trans message="Email" />}
                        name="email"
                        required
                        type="email"
                        className="rounded-lg p-2"
                      />
                      <FormTextField
                        label={<Trans message="Mobile Number" />}
                        name="mobileNumber"
                        required
                        type="number"
                        className="rounded-lg p-2"
                      />
                      <FormTextField
                        label={<Trans message="Message" />}
                        name="message"
                        required
                        inputElementType="textarea"
                        className="rounded-lg p-2"
                        rows={5}
                      />
    
                      <div className="mt-4 flex w-full justify-between gap-4">
                        <Button
                          variant="flat"
                          onClick={() => setIsContactDialogOpen(false)}
                          className="rounded-lg px-4 py-2 text-lg"
                        >
                          <Trans message="Back" />
                        </Button>
                        <Button
                          type="submit"
                          variant="flat"
                          color="primary"
                          className="rounded-lg px-4 py-2 text-lg"
                        >
                          <Trans message="Send Message" />
                        </Button>
                      </div>
                    </Form>
                  )}
                </DialogBody>
              </Dialog>
            </DialogTrigger>
          )}
        </>
      );
    }
    
    function calculateCost({ tb }: any) {
      const tbInput: any = tb;
      const errorMsg: any = document.getElementById('errorMsg');
      const resultOutput: any = document.getElementById('resultOutput');
    
      // Reset messages
      errorMsg.textContent = '';
      resultOutput.textContent = '';
    
      // Validation: Ensure input is a positive integer and greater than 5
      if (!/^\d+$/.test(tbInput)) {
        errorMsg.textContent = 'Error: Storage must be a whole number!';
        return;
      }
    
      const tbValue = parseInt(tbInput, 10);
    
      if (tbValue <= 5) {
        errorMsg.textContent = 'Error: Storage must be greater than 5 TB!';
        return;
      }
    
      // Conversion and cost calculation
      const gbStorage = tbValue * 1024; // Convert TB to GB
      const cost = gbStorage * 0.15; // Calculate cost
    
      // Display result
      resultOutput.innerHTML = `
          Storage: <strong>${tbValue.toLocaleString()} TB</strong><br>
          Total Cost: <strong>₹${cost.toFixed(2)}/month</strong><br>
          GST and Convenience Fee Extra**
      `;
    }
    
    function ReviewCard({
      item,
      isActive,
    }: {
      item: any;
      isActive: boolean;
    }) {
      const { name, role, avatar, review, accent, light, rating } = item;
      
      // Extract the first letter of the name
      const initial = name?.charAt(0).toUpperCase() || "U";
    
      return (
        <div
          className={[
            "relative flex-shrink-0 overflow-hidden m-10 rounded-[28px] border-[1.5px] p-[clamp(24px,3.5vw,42px)] transition-all duration-500 flex flex-col justify-between",
            isActive ? "translate-y-[-4px] scale-[1.015]" : "scale-[0.97]",
          ].join(" ")}
          style={{
            minWidth: "clamp(270px, 42vw, 450px)",
            maxWidth: "clamp(270px, 42vw, 450px)",
            background: isActive
              ? `linear-gradient(150deg, ${light} 0%, white 100%)`
              : `linear-gradient(150deg, ${light}88 0%, #f8fafc 100%)`,
            borderColor: isActive ? `${accent}50` : "#e2e8f0",
            boxShadow: isActive
              ? `0 24px 60px ${accent}1a, 0 4px 16px ${accent}10`
              : "0 2px 12px rgba(0,0,0,0.05)",
            opacity: isActive ? 1 : 0.68,
          }}
        >
          <div>
            {/* Rating Section */}
            <div className="flex items-center justify-between mb-6">
              <div className="flex gap-1">
                {[...Array(5)].map((_, i) => (
                  <span key={i} style={{ color: i < rating ? accent : "#cbd5e1" }} className="text-[18px]">
                    ★
                  </span>
                ))}
              </div>
              {/* Subtle Quote Mark */}
              <span className="font-serif text-[60px] leading-none opacity-10 absolute right-8 top-6" style={{ color: accent }}>
                “
              </span>
            </div>
    
            <p className="font-archivo text-[clamp(14px,1.15vw,16px)] font-medium leading-[1.7] mb-8 text-[#334155]">
              "{review}"
            </p>
          </div>
    
          <div className="flex items-center gap-10">
            {/* AVATAR / INITIAL BOX */}
            <div 
              className="flex h-50 w-50 shrink-0 items-center justify-center rounded-full border-2 font-archivo text-[20px] font-bold"
              style={{ 
                borderColor: `${accent}40`,
                background: isActive ? `${accent}15` : "#f1f5f9",
                color: accent 
              }}
            >
              {avatar ? (
                <img src={avatar} alt={name} className="h-full w-full object-cover rounded-full" />
              ) : (
                <span>{initial}</span> 
              )}
            </div>
    
            <div className="overflow-hidden ">
              <h4 className="truncate font-archivo text-[17px] font-bold text-[#0f172a] leading-tight">
                {name}
              </h4>
              <p className="truncate text-[13px] font-semibold" style={{ color: accent }}>
                {role}
              </p>
            </div>
          </div>
    
          <div
            className="absolute bottom-0 left-0 h-[3px] rounded-bl-[28px] transition-all duration-[650ms] ease-[cubic-bezier(0.4,0,0.2,1)]"
            style={{
              width: isActive ? "100%" : "0%",
              background: `linear-gradient(90deg, ${accent}, ${accent}44)`,
            }}
          />
        </div>
      );
    }
    
    const C = {
      paper: "#f5f8ff",
      warm: "#beccf0", 
      ink: "#1E3A8A",
      accent: "#0072ff",
      muted: "#9a9a9b",
    } as const;
    
    const font = {
      serif: { fontFamily: "'Archivo', sans-serif" },
      mono: { fontFamily: "'Archivo', sans-serif" },
    } as const;
    
    interface Benefit {
      num: string;
      Icon: FC;
      title: string;
      text: React.ReactNode;
    }
    
    
    const BENEFITS: Benefit[] = [
      {
        num: "01 / 04",
        Icon: ShieldCheck ,
        title: "Secure Storage for Large Video Files ",
        text: (
        <>
          Store raw footage, edited videos, thumbnails, and project files safely with{" "}
          <a
            href="#security"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#0072ff] font-bold hover:underline"
          >
            SpaceByte cloud storage,
          </a>{" "}
          protecting content if devices fail.
        </>
      ),
      },
      {
        num: "02 / 04",
        Icon: Globe ,
        title: "Fast Uploads for Video Projects",
        text: "Upload large 4K or 8K video files quickly so your editing and publishing workflow stays smooth.",
      },
      {
        num: "03 / 04",
        Icon: FolderKanban  ,
        title: "Organized Video Project Folders",
        text: "Keep your raw footage, thumbnails, scripts, and final videos organized so you can find files quickly.",
      },
      {
        num: "04 / 04",
        Icon: Share2 ,
        title: "Easy Collaboration with Editors",
        text: "Share project folders with editors, designers, or sponsors using secure links for simple and secure collaboration.",
      },
    ];
    
    function useStyles(): void {
      useEffect(() => {
    
        // CSS Keyframes + Animations
        if (!document.getElementById("ben-css")) {
          const s = document.createElement("style");
          s.id = "ben-css";
          s.textContent = `
            .ben-reveal {
              opacity: 0;
              transform: translateY(28px);
              transition: opacity 0.75s ease, transform 0.75s ease;
            }
            .ben-reveal.visible {
              opacity: 1;
              transform: translateY(0);
            }
    
            .ben-card {
              position: relative;
              overflow: hidden;
              cursor: default;
            }
            .ben-card-inner {
              transition: background 0.4s ease;
            }
            .ben-card:hover .ben-card-inner {
              background: ${C.ink} !important;
            }
    
            .ben-card::after {
              content: '';
              position: absolute;
              bottom: 0; left: 0; right: 0;
              height: 2px;
              background: ${C.accent};
              transform: scaleX(0);
              transform-origin: left;
              transition: transform 0.4s ease;
            }
            .ben-card:hover::after { transform: scaleX(1); }
    
            .ben-num, .ben-title, .ben-text {
              transition: color 0.4s ease;
            }
            .ben-card:hover .ben-num { color: #1E3A8A !important; }
            .ben-card:hover .ben-title { color: ${C.paper} !important; }
            .ben-card:hover .ben-text { color: #d8d8da !important; }
    
            .ben-icon {
              width: 52px; height: 52px;
              display: flex; align-items: center; justify-content: center;
              border: 1.5px solid ${C.warm};
              background: ${C.warm};
              transition: all 0.4s ease;
            }
            .ben-icon svg { stroke: ${C.ink}; transition: stroke 0.4s ease; }
            .ben-card:hover .ben-icon {
              background: ${C.accent} !important;
              border-color: ${C.accent} !important;
            }
            .ben-card:hover .ben-icon svg { stroke: #ffffff; }
    
            .ben-card:nth-child(1) { transition-delay: 0s; }
            .ben-card:nth-child(2) { transition-delay: 0.08s; }
            .ben-card:nth-child(3) { transition-delay: 0.16s; }
            .ben-card:nth-child(4) { transition-delay: 0.24s; }
          `;
          document.head.appendChild(s);
        }
      }, []);
    }
    
    // ── Scroll Reveal Hook ────────────────────────────────────────────────────────
    function useReveal(ref: React.RefObject<HTMLElement>): void {
      useEffect(() => {
        const el = ref.current;
        if (!el) return;
    
        const obs = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              el.classList.add("visible");
              obs.disconnect();
            }
          },
          { threshold: 0.1 }
        );
        
        obs.observe(el);
        return () => obs.disconnect();
      }, [ref]);
    }
    
    // ── Benefit Card Component ────────────────────────────────────────────────────
    const BenefitCard: FC<Benefit> = ({ num, Icon, title, text }) => (
      <div className="ben-card">
        <div
          className="ben-card-inner h-full"
          style={{
            background: C.paper,
            padding: "clamp(32px, 4vw, 52px) clamp(24px, 3.5vw, 44px)",
          }}
        >
          {/* <p
            className="ben-num font-archivo"
            style={{
              fontSize: 11,
              letterSpacing: "0.2em",
              color: C.muted,
              marginBottom: 24,
            }}
          >
            {num}
          </p> */}
    
          <div className="ben-icon rounded-2xl" style={{ marginBottom: 24 }}>
            <Icon />
          </div>
    
          <h3
            className="ben-title font-archivo font text-2xl"
            style={{
              color: C.ink,
              marginBottom: 12,
            }}
          >
            {title}
          </h3>
    
          <p
            className="ben-text font-archivo"
            style={{
              fontSize: "clamp(14px, 1.2vw, 15px)",
              lineHeight: 1.8,
              color: C.muted,
              fontWeight: 300,
              maxWidth: 360,
            }}
          >
            {text}
          </p>
        </div>
      </div>
    );
    
    function WhyCard({
      item,
    }: {
      item: {
        icon: LucideIcon;
        title: string;
        text: string;
      };
    }) {
      const { icon: Icon, title, text } = item;
    
      return (
        <div
          className="
            relative overflow-hidden rounded-[16px] border
            p-[32px_28px]
            transition-all duration-500
            ease-[cubic-bezier(0.4,0,0.2,1)]
            hover:-translate-y-[6px]
            hover:shadow-[0_16px_40px_rgba(0,112,255,0.12)]
          "
          style={{
            background: "#f5f8ff",
            borderColor: "#e4edff",
    
            /* ✅ Top Gradient Line (Best Professional Way) */
            backgroundImage:
              "linear-gradient(90deg, #0070ff, #00c6ff)",
            backgroundSize: "100% 4px",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "top",
          }}
        >
          {/* Icon */}
          <div
            className="w-[50px] h-[50px] rounded-[12px] flex items-center justify-center text-[22px] mb-[18px]"
            style={{
              background: "#eaf3ff",
            }}
          >
            <Icon size={22} strokeWidth={2} className="text-[#0070ff]" />
          </div>
    
          {/* Title */}
          <h3 className="text-[16px] font-bold text-[#0d0d2b] mb-[10px]">
            {title}
          </h3>
    
          {/* Text */}
          <p className="text-[13.5px] text-[#7a8fa6] leading-[1.7]">
            {text}
          </p>
        </div>
      );
    }